import { z } from 'zod';

export const AccessScopeSchema = z.enum(['ORG','SYSTEM','WORKFLOW','WORKFLOW_TYPE','SITE_WORKFLOW_TYPE','ORG_WORKFLOW_TYPE','TENANT']);

export type AccessScopeType = `${z.infer<typeof AccessScopeSchema>}`

export default AccessScopeSchema;
